<template>
    <div class="block-editor remove-from-segment">
        <div class="wrapper">
            <span class="title">Segment</span>
            <SegmentPicker v-model="clone.segmentId" />
        </div>
    </div>
</template>

<script>
import SegmentPicker from "../pickers/SegmentPicker";
import _ from "lodash";

export default {
    name: "RemoveSegment",
    components: { SegmentPicker },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.block-editor.remove-from-segment {
    margin-bottom: 50px;

    .wrapper {
        padding: 0 10px;
        width: 100%;
        display: flex;
        flex-direction: column;

        .title {
            margin-bottom: 5px;
            color: #22272d;
            font-weight: 600;
        }
    }
}
</style>
